import React from "react";
import _ from "lodash";
import PropTypes from 'prop-types';
import { Image } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroller";

import ContactShareContainer from "../shares";
import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import RolodexActivityEmptyMessage from "src/legacy/images/rolodexActivityEmptyMessage.svg";

import styles from "./styles.module.scss";

const PaperfliteIcon = '/images/Paperflite.png';

export default class ContactConversationView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentPage: this.props.currentPage,
      showShareView: false,
      showDeleteConfirmation: false,
      fetchShares: false

    };

    this._handleUpdateClicked = this._handleUpdateClicked.bind(this);
    this._handleDeleteClicked = this._handleDeleteClicked.bind(this);
    this.loadMoreShares = this.loadMoreShares.bind(this);
    this._handleEmptyMsgActionClick =
      this._handleEmptyMsgActionClick.bind(this);
  }

  loadMoreShares(page) {
    if (!this.props.contact) {
      return;
    }

    if (this.props.loading) {
      return;
    }

    this.props.fetchContactShareAnanlytics(this.props.contact.id, page);
  }

  componentDidMount() {

    this.props.fetchUserProfile();

    if (this.props.id) {
      this.props.fetchData(this.props.id);

    }
    if (this.props.contact) {
      this.props.fetchContactShareAnanlytics(this.props.contact.id, 0);
      this.setState({ render: true })

    }

  }

  componentWillReceiveProps(nextProps) {

    var current = this.props.contact;
    var next = nextProps.contact;

    var changed = true;
    if (current && next) {
      changed = current.id != next.id;
    }

    if (changed && next) {
      this.props.fetchContactShareAnanlytics(next.id, 0);
    }

    if (!_.isEqual(this.props.location.query, nextProps.location.query)) {
      this.props.fetchData(this.props.id);
    }
  }

  _handleUpdateClicked() {
    if (this.props.onUpdateClicked) {
      this.props.onUpdateClicked();
    }
  }

  _handleDeleteClicked() {
    this.setState({
      showDeleteConfirmation: true,
    });
  }

  renderName() {
    return `${this.props.contact.firstName || ""} ${this.props.contact.lastName || ""
      }`;
  }

  renderInitials() {
    let initial = "";

    if (this.props.contact.firstName) {
      initial = this.props.contact.firstName.charAt(0);
    }

    if (this.props.contact.lastName) {
      initial = initial + this.props.contact.lastName.charAt(0);
    }

    return initial.toUpperCase();
  }

  _handleEmptyMsgActionClick() {
    this.setState({
      showShareView: true,
    });
  }

  _handleFetchSection(share, section) {
    return this.props.fetchShareSection(this.props.contact.id, share, section);
  }

  render() {
    if (!this.props.contact && !this.props.loadingContact) {
      return this._renderEmptyMessage();
    }

    return (
      <div className={styles.conversationContainer}>
        <div className={styles.headerContainer}>
          <div className={styles.title}>
            <h4> Shares </h4>
          </div>

          <div className={styles.headerLogo}>
            <span className={styles.headerLogoText}> Powered by </span>
            <Image className={styles.headerLogo} src={PaperfliteIcon} />
          </div>
        </div>

        <div className={styles.shareContainer}>{this._renderShares()}</div>

        {this.props.loadingShares && (
          <div className={styles.loading}>Loading shares... </div>
        )}

        {this.props.backdrop && <div className={styles.overlay}></div>}
      </div>
    );
  }

  _renderShares() {
    if (this.state.fetchShares && !this.props.loadingShares && this.props.shares.length == 0) {
      return this._renderEmptyMessage();
    }

    var shares = this.props.shares.map((share) => {
      return (
        share && (
          <ContactShareContainer
            key={share.id}
            id={share.id}
            page={this.state.currentPage}
            contact={this.props.contact.id}
            fetchAssetAnalytics={this.props.fetchAssetAnalytics.bind(this)}
            fetchShareSection={this._handleFetchSection.bind(this)}
          />
        )
      );
    });

    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.props.currentPage < this.props.totalPages}
        loadMore={(page) => {
          this.loadMoreShares(page);
        }}
        useWindow={true}
        threshold={250}
      >
        {shares}
      </InfiniteScroll>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title="No visibility yet! This space is reserved for contact level analytics."
        message={`Share some material and we’ll show you how ${this.props.contact ? this.props.contact.firstName : ''
          }  engaged with your content.`}
        image={RolodexActivityEmptyMessage}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }
}